/**
 * Выход в одной вкладке браузера — выход во всех (D-075). Без этого соседняя
 * вкладка того же пользователя первым же действием записала бы в хранилище
 * только что стёртые записи. BroadcastChannel доступен не везде — тогда
 * канал молчит, и соседняя вкладка узнает о выходе по 401 на следующем запросе.
 */
export interface SessionChannel {
  announceSignOut(userId: string): void
  onSignOut(listener: (userId: string) => void): () => void
}

const CHANNEL = 'krp:session'

export function browserSessionChannel(): SessionChannel {
  if (typeof BroadcastChannel === 'undefined') return silentSessionChannel()
  const channel = new BroadcastChannel(CHANNEL)
  return {
    announceSignOut: (userId) => channel.postMessage({ type: 'signed-out', userId }),
    onSignOut: (listener) => {
      const handle = (event: MessageEvent<unknown>) => {
        const data = event.data as { type?: unknown; userId?: unknown } | null
        if (data?.type === 'signed-out' && typeof data.userId === 'string') listener(data.userId)
      }
      channel.addEventListener('message', handle)
      return () => channel.removeEventListener('message', handle)
    },
  }
}

export function silentSessionChannel(): SessionChannel {
  return { announceSignOut: () => {}, onSignOut: () => () => {} }
}
